module.exports = __webpack_public_path__ + "static/img/bg_jcjg_icon.png";